<template>
  <div class="page-class page-center">
    <div class="page-staff-form">
      <h1 class="page-title text-center">{{ title }}</h1>
      <expense-request-block-form-box :form-type="formType" @add="onAdd" @edit="onEdit" isDisableCompanyField="true" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ExpenseRequestBlockFormBox from '../../../components/PettyCash/ExpenseRequestBlockFormBox.vue';

export default {
  name: 'ExpenseSettingForm',
  components: { ExpenseRequestBlockFormBox },
  data() {
    return { id: null, formType: this.$route.name === 'petty-cash-expense-setting-new' ? 'new' : 'update' };
  },
  computed: {
    title() {
      return this.formType === 'new' ? 'Add New Expense Setting' : 'Update Expense Setting';
    }
  },
  mounted() {
    if (this.formType === 'update') {
      this.id = this.$route.params.id;
      this.getOne({ id: this.id, router: this.$router });
    }
  },
  methods: {
    ...mapActions('expenseRequestBlock', ['getOne', 'postOne', 'patchOne']),
    onAdd({ setting }) {
      this.postOne({ setting, router: this.$router, redirectUrl: '/petty-cash/expense-setting' });
    },
    onEdit({ setting }) {
      this.patchOne({ id: this.id, setting, router: this.$router, redirectUrl: '/petty-cash/expense-setting' });
    }
  }
};
</script>
